export default __webpack_public_path__ + "static/media/carousel-visahq.484ef0c4.jpg";